import React, { useRef, useState } from "react";
import emailjs from '@emailjs/browser';
import { Mail, Phone, User, MessageSquare } from "lucide-react";
import SimpleHeader from 'components/SimpleHeader';
import ReCAPTCHA from "react-google-recaptcha";


// EmailJS Ayarları, ecosystem.config.js veya .env dosyasından okunur.
// UYGULAMAYI YENİDEN BAŞLATMAYI UNUTMAYIN!
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;


const ContactPage = () => {
  const form = useRef();
  const recaptchaRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);


  const CONTACT_INFO = {
    phone: ['+90 554 698 31 44', '+90 534 603 10 99'],
    email: "info@anoraforever.com",
    address_main: `Sultan Selim Mah. 
    Eski Büyükdere Caddesi 
    No:61 Kat:2
    Kağıthane / İSTANBUL`,
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 🔑 Anahtar Kontrolü: 3 Anahtarın da yüklenip yüklenmediği kontrol edilir.
    if (!EMAILJS_PUBLIC_KEY || !EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID) {
      alert("Hata: EmailJS anahtarları yüklenemedi. Lütfen ecosystem.config.js dosyanızı kontrol edin.");
      // Geliştirme aşamasında console'a hata detaylarını yazmak faydalıdır.
      console.error("Missing EmailJS Keys:", { EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, EMAILJS_PUBLIC_KEY });
      return;
    }

    // reCAPTCHA doğrulaması
    if (!recaptchaToken) {
      alert("Lütfen 'Ben robot değilim' kutusunu işaretleyin.");
      return;
    }

    setIsSubmitting(true);

    emailjs.sendForm(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      form.current,
      EMAILJS_PUBLIC_KEY
    )
      .then((result) => {
        alert("Mesajınız başarıyla gönderildi! Kısa süre içinde dönüş yapacağız.");
        form.current.reset(); // Başarılı gönderim sonrası formu temizle
        recaptchaRef.current.reset();
      }, (error) => {
        console.error('Mesaj gönderilirken hata oluştu:', error);
        alert(`Mesaj gönderilirken bir hata oluştu: ${error.text}. Lütfen daha sonra tekrar deneyin.`);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="min-h-dvh bg-background text-foreground overflow-x-hidden">
      <SimpleHeader />

      <main className="flex-1 flex flex-col pt-16 md:pt-24 pb-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">

          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-center mb-4 text-neutral-900 font-sans">
            Bize Ulaşın
          </h1>
          <p className="text-center text-lg text-neutral-600 mb-12 max-w-xl mx-auto">
            Sorularınız mı var? Ekibimizle iletişime geçmek için formu doldurun veya doğrudan bizi arayın.
          </p>

          <div className="grid md:grid-cols-3 gap-8">

            {/* --- İLETİŞİM BİLGİLERİ --- */}
            <div className="md:col-span-1 space-y-6">

              {/* Telefon Alanı */}
              {/* Telefon Alanı */}
              <div className="p-5 border border-rose-100 rounded-xl bg-white/70 shadow-sm transition hover:shadow-md">
                <div className="size-10 rounded-full bg-rose-500/10 text-rose-700 grid place-items-center mb-3">
                  <Phone className="w-6 h-6" />
                </div>
                <h3 className="font-semibold text-neutral-800">Telefon</h3>
                {CONTACT_INFO.phone.map((p, index) => (
                  <a
                    key={index}
                    href={`tel:${p.replace(/\s/g, '')}`}
                    className="text-sm text-neutral-600 hover:text-rose-700 transition block"
                  >
                    {p}
                  </a>
                ))}
              </div>
              {/* Mail Alanı */}
              <div className="p-5 border border-rose-100 rounded-xl bg-white/70 shadow-sm transition hover:shadow-md">
                <div className="size-10 rounded-full bg-rose-500/10 text-rose-700 grid place-items-center mb-3">
                  <Mail className="w-6 h-6" />
                </div>
                <h3 className="font-semibold text-neutral-800">E-posta</h3>
                <a href={`mailto:${CONTACT_INFO.email}`} className="text-sm text-neutral-600 hover:text-rose-700 transition">
                  {CONTACT_INFO.email}
                </a>
              </div>

              {/* Adres Alanı (Opsiyonel) */}
              <div className="p-5 border border-rose-100 rounded-xl bg-white/70 shadow-sm transition hover:shadow-md">
                <div className="size-10 rounded-full bg-rose-500/10 text-rose-700 grid place-items-center mb-3">
                  <MessageSquare className="w-6 h-6" />
                </div>
                <h3 className="font-semibold text-neutral-800">Adres</h3>
                <p className="text-sm text-neutral-600 flex flex-col">
                  {CONTACT_INFO.address_main.split('\n').map((line, index) => (
                    <span key={index}>{line}</span>
                  ))}
                </p>
              </div>

            </div>

            {/* --- İLETİŞİM FORMU --- */}
            <div className="md:col-span-2 p-8 border border-rose-100 rounded-2xl bg-white/70 shadow-lg backdrop-blur-sm">
              <form ref={form} onSubmit={handleSubmit} className="space-y-4">

                {/* Ad Soyad */}
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-neutral-700 mb-1">Adınız Soyadınız *</label>
                  <div className="relative">
                    <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
                    <input
                      type="text"
                      id="name"
                      name="user_name" // 🔑 EmailJS şablonundaki değişken ile eşleşmeli
                      required
                      placeholder="Adınızı girin"
                      className="w-full pl-10 pr-3 py-2 border border-input rounded-lg focus:ring-rose-500 focus:border-rose-500 transition shadow-sm"
                    />
                  </div>
                </div>

                {/* E-posta */}
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-neutral-700 mb-1">E-posta Adresiniz *</label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
                    <input
                      type="email"
                      id="email"
                      name="user_email" // 🔑 EmailJS şablonundaki değişken ile eşleşmeli
                      required
                      placeholder="eposta@adresiniz.com"
                      className="w-full pl-10 pr-3 py-2 border border-input rounded-lg focus:ring-rose-500 focus:border-rose-500 transition shadow-sm"
                    />
                  </div>
                </div>

                {/* Telefon Numarası */}
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-neutral-700 mb-1">Telefon Numarası</label>
                  <div className="relative">
                    <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" />
                    <input
                      type="tel"
                      id="phone"
                      name="user_phone" // 🔑 EmailJS şablonundaki değişken ile eşleşmeli
                      placeholder="05XX XXX XX XX (Opsiyonel)"
                      className="w-full pl-10 pr-3 py-2 border border-input rounded-lg focus:ring-rose-500 focus:border-rose-500 transition shadow-sm"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="subject_select" className="block text-sm font-medium text-neutral-700 mb-1">Konu Seçiniz *</label>
                  <div className="relative">
                    <select
                      id="subject_select"
                      name="subject_selection" // 🔑 Yeni Değişken Adı: subject_selection
                      required
                      className="w-full pl-3 pr-3 py-2 border border-input rounded-lg focus:ring-rose-500 focus:border-rose-500 transition shadow-sm"
                    >
                      <option value="" disabled>Lütfen bir konu seçin</option>
                      <option value="Öneri veya Destek Talebi">Öneri veya Destek Talebi</option>
                      <option value="İade Talebi">İade Talebi</option>
                      <option value="Ortaklık Talebi">Ortaklık Talebi</option>
                    </select>
                  </div>
                </div>

                {/* Mesaj Alanı */}
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-neutral-700 mb-1">Mesajınız *</label>
                  <textarea
                    id="message"
                    name="message" // 🔑 EmailJS şablonundaki değişken ile eşleşmeli
                    rows="4"
                    required
                    placeholder="Detaylı mesajınızı buraya yazın..."
                    className="w-full p-3 border border-input rounded-lg focus:ring-rose-500 focus:border-rose-500 transition shadow-sm resize-none"
                  ></textarea>
                </div>

                {/* reCAPTCHA */}
                <div className="flex justify-center">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={RECAPTCHA_SITE_KEY}
                    onChange={(token) => setRecaptchaToken(token)}
                    onExpired={() => setRecaptchaToken(null)}
                  />
                </div>

                {/* Gönder Butonu */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full py-3 rounded-full font-semibold transition duration-300 shadow-lg shadow-rose-500/30 ${isSubmitting ? 'bg-rose-400 text-white cursor-not-allowed' : 'bg-[#e45078] text-white hover:bg-rose-600'
                    }`}
                >
                  {isSubmitting ? 'Gönderiliyor...' : 'Mesajı Gönder'}
                </button>
              </form>
            </div>
            {/* --- İLETİŞİM FORMU BİTİŞİ --- */}

          </div>
        </div>
      </main>

      {/* Footer bileşenini buraya ekleyebilirsiniz */}
      <footer className="border-t border-rose-100 py-8">
        {/* Footer içeriği... */}
      </footer>
    </div>
  );
};

export default ContactPage;